<template>
  <div class="md container mx-auto py-8 px-8 text-center text-navy leading-normal">
    <div>
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs></defs>
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="footer/footer-desktop" transform="translate(-89.000000, -37.000000)" fill="#2BCC83" fill-rule="nonzero">
                  <g id="Group-2" transform="translate(44.000000, 35.000000)">
                      <g id="Group-5">
                          <g id="Group-4" transform="translate(45.000000, 0.000000)">
                              <path d="M15.285,14.305 L12.707,11.711 C12.317,11.318 11.682,11.318 11.291,11.709 L9,14 L4,9 L6.294,6.706 C6.684,6.316 6.685,5.683 6.295,5.292 L3.715,2.708 C3.324,2.317 2.691,2.317 2.3,2.708 L0.004,5.003 L0,5 C0,12.18 5.82,18 13,18 L15.283,15.717 C15.673,15.327 15.674,14.696 15.285,14.305 Z" id="Shape"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
      <strong>Need help?</strong>
      <p> Call (02) 7501 1110 Mon-Fri (8am-5pm AEST) </p>
        <p>Email s1-brokersupport@moneyme.com.au </p>
    </div>
    <div class="text-navy-lighter mt-4">
      SocietyOne Australia Pty Ltd ACN 151 627 977. Australian Credit Licence No. 423660
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrokerSignIn',
}
</script>



// WEBPACK FOOTER //
// src/components/BrokerFooter.vue